// Função que converte uma string de horário (exemplo: 19:35) em um inteiro representando minutos.
export const timeToMinutes = (timeStr) => {
  if (!timeStr) return 0;
  const [hours, minutes] = timeStr.split(':').map(Number);
  return hours * 60 + minutes;
};

// Função que verifica se uma string de hora (exemplo: 13:10) está dentro do intervalo de almoço lunchInterval.
export const isLunchBreak = (timeString, lunchInterval) => {
    const t = timeToMinutes(timeString);
    const s = timeToMinutes(lunchInterval.start.split(':').slice(0,2).join(':'));
    const e = timeToMinutes(lunchInterval.end.split(':').slice(0,2).join(':'));

    return t >= s && t < e;
};
